import { render, staticRenderFns } from "./MainResource.vue?vue&type=template&id=1c1b6a6b&scoped=true&"
import script from "./MainResource.vue?vue&type=script&lang=js&"
export * from "./MainResource.vue?vue&type=script&lang=js&"
import style0 from "./MainResource.vue?vue&type=style&index=0&id=1c1b6a6b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1b6a6b",
  null
  
)

export default component.exports